/* global FormValidation, grecaptcha, onFormSubmit, getFormValue, localData */
// **************************************************
// Count how many characters are left in textarea
// **************************************************

window.addEventListener('spectoCmsContentLoaded', () => {
  const isSpecto = window.location.href.includes('specto') || window.location.href.includes('localhost');

  document.querySelectorAll('.form-module__textarea').forEach((textarea) => {
    const charCount = textarea.closest('.form-module__form-input').querySelector('.form-module__word-limit');

    textarea.addEventListener('input', () => {
      charCount.innerHTML = textarea.maxLength - textarea.value.length;
    });
  });

  const showFormError = (error, formParent, formAlertError) => {
    formParent.classList.add('show-error');
    formAlertError.classList.remove('hide');
  }

// *******************************************************************************
// Form handling
// *******************************************************************************

  window.handleForm = (form, formAction, FormNonce) => {
    const formParent = form.closest('[data-parent]');
    const formAlertError = formParent.querySelector('.form__alert-error');

    const fv = FormValidation.formValidation(form, {
      locale: 'sl_SI',
      localization: FormValidation.locales.sl_SI,
      fields: {},
      plugins: {
        message: new FormValidation.plugins.Message({
          container: (field, element) => element.closest('.form-module__form-input,.radio-button,.dropdown,.checkbox,.form-group'),
        }),
        declarative: new FormValidation.plugins.Declarative({
          html5Input: true,
        }),
        trigger: new FormValidation.plugins.Trigger({
          event: 'submit',
        }),
        submitButton: new FormValidation.plugins.SubmitButton(),
      },
    })
      .on('core.element.validated', (e) => {
        if (e.element.hasAttribute('required')) {
          const value = fv.getElementValue(e.field, e.element);
          const container = FormValidation.utils.closest(e.element, '.form-module__form-input,.radio-button,.dropdown,.checkbox,.form-group');
          FormValidation.utils.classSet(container, {
            'is-validation-failed': value === '' || !e.valid,
          });
        }
      })
      .on('core.form.valid', async () => {
        // FOR TESTING ONLY
        // grecaptcha.ready(async () => {
        //   const token = await grecaptcha.execute(localData.captchaSiteKey, { action: formAction });
        const submitBtn = formParent.querySelector('.btn[type="submit"]');
        submitBtn?.setAttribute('disabled', true);
        formParent.classList.add('show-loader');

        const formData = {};

        form.querySelectorAll('input, textarea, select').forEach((input) => {
          const getValue = input.value.trim();
          if (input.type !== 'checkbox' && input.type !== 'radio' && input.type !== 'hidden') {
            formData[input.name] = getValue;
          }
          if (input.type === 'radio') {
            if (input.checked) {
              formData[input.name] = getValue;
            }
          }
        });

        const urlParams = new URLSearchParams(window.location.search);
        const hash = urlParams.get('hash');

        const ajaxData = {
          action: formAction,
          nonce: FormNonce,
          inputs: JSON.stringify(formData),
          id: form.querySelector('[data-page-id]').value,
          k: form.querySelector('[data-k]').value,
          formType: form.querySelector('[data-form-type]').value,
          hash,
          lang: localData.lang,
        }

        try {
          const response = await axios
            .post(localData.siteURL, ajaxData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })

          if (response?.status === 200) {
            formParent.classList.remove('show-loader');
            formParent.classList.add('show-thankyou');
            submitBtn?.removeAttribute('disabled')
          }
        } catch (error) {
          showFormError(error, formParent, formAlertError);
          submitBtn?.removeAttribute('disabled')
        }
        ;
        // });
      });
  };

  const initForm = () => {
    ['form-module-form', 'newsletter-form'].forEach((id) => {
      const form = document.querySelector(`#${id}`);
      if (form) {
        const formAction = form.querySelector('[data-action]').value;
        const formNonce = form.querySelector('[data-nonce]').value;
        handleForm(form, formAction, formNonce);
      }
    });
  }

  if (isSpecto) {
    document.addEventListener('DOMContentLoaded', () => {
      initForm();
    });
  } else {
    const newsletterForm = document.querySelector('#newsletter-form');
    if (newsletterForm && newsletterForm.getAttribute('listener') !== 'true') {
      newsletterForm?.addEventListener('submit', async (event) => {
        event.preventDefault();
        const formContainer = event?.target?.closest('[data-parent]');
        const submitBtn = newsletterForm.querySelector('.btn[type="submit"]');
        submitBtn?.setAttribute('disabled', true);
        formContainer.classList.add('show-loader');
        const formError = formContainer.querySelector('.form__alert-error');
        const formData = {};

        for (const element of event?.target?.elements) {
          if (element.name) {
            formData[element.name] = element.value;
          }
        }
        try {
          const response = await subscribeToNewsletter({ email: formData.newsletter_email });
          if (response?.data === 'ok') {
            formContainer.classList.remove('show-loader');
            formContainer.classList.add('show-thankyou');
            submitBtn?.removeAttribute('disabled')
          }
        } catch (error) {
          showFormError(error, formContainer, formError);
          submitBtn?.removeAttribute('disabled')
        }
      });

      newsletterForm.setAttribute('listener', 'true');
    }
  }
});
